import React, { useCallback } from "react";
import styled from "styled-components";
import Organization from "~/components/user/WelcomeForm/Organization";

const Overlay = styled.div`
  background: white;
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: white;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
`;

const Main = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  // Add padding to the top of the overlay to account for the fixed header
  padding-top: 50px;
`;

const MainLayout = styled.div`
  max-width: 1400px;
  position: relative;
  width: 90%;
  height: 100%;
  max-height: 785px;

  font-size: 15px;

  @media (min-width: 1025px) {
    font-size: 16px;
  }

  @media (min-width: 1281px) {
    font-size: 18px;
  }
`;

interface Props {
  // An optional provided product that the user just signed up for. If provided,
  // we should respect this product and render the appropriate final step.
  product?: Product;

  viewer: {
    user: {
      uuid: string;
      name: string;
      avatar: {
        url: string;
      };
    };
  };
}

const Container = styled.div`
  position: relative;
`;

const Box = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-columns: 100%;
  height: 100%;
`;

enum Product {
  Pipelines = "pipelines",
  TestAnalytics = "analytics",
  Packages = "packages",
}

const WelcomeForm: React.FunctionComponent<Props> = ({ viewer: { user }, product }) => {
  const redirectToProduct = useCallback(
    (organization) => {
      switch (product) {
        case Product.TestAnalytics:
          window.location.href = `/organizations/${organization.slug}/analytics`;
          break;
        default:
          window.location.href = `/organizations/${organization.slug}`;
      }
    },
    [product],
  );

  return (
    <Overlay>
      <Main>
        <MainLayout className="flex justify-center">
          <Container className="max-w-sm">
            <Box>
              <Container>
                <Organization onSuccess={redirectToProduct} user={user} />
              </Container>
            </Box>
          </Container>
        </MainLayout>
      </Main>
    </Overlay>
  );
};

export { WelcomeForm };
